import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import en from "./en.json";
import vi from "./vi.json";
import da from "./da.json";

export const fetchTranslation = async (lng: string, token?: string) => {
  try {
    const response = await fetch(
      `https://backend.titanplan.com/i18n/translate/getTranslations/${lng}?json=true`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          ...(token ? { Token: `${token}` } : {}),
        },
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Lỗi khi tải dữ liệu dịch:", error);
    return {};
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    debug: true,
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: { translation: en },
      vi: { translation: vi },
      da: { translation: da },
    },
    defaultNS: "translation",
  });

// Hàm initTranslations có thể nhận token
export const initTranslations = async (lng: string, token?: string) => {
  const translations = await fetchTranslation(lng, token);
  i18n.addResourceBundle(lng, "translation", translations, true, true);
  await i18n.changeLanguage(lng);
};

export default i18n;
